import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`common.components.confirm`, {
  'common.cancel': `Cancel`,
  'common.delete': `Delete`,
  'common.okay': `Okay`,
  'common.save': `Save`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.components.confirm"), "fr": () => import("virtual:i18n-scope/fr/common.components.confirm"), "id": () => import("virtual:i18n-scope/id/common.components.confirm"), "ja": () => import("virtual:i18n-scope/ja/common.components.confirm"), "ko": () => import("virtual:i18n-scope/ko/common.components.confirm"), "pt": () => import("virtual:i18n-scope/pt/common.components.confirm"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.components.confirm"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.components.confirm")});
export default __i18nScope;
